const founders = [
  {
    img: "/img1.jpeg",
    name: "Dr. Shilpa Bhardwaj Mishra",
    role: "CEO & Owner",
    badge: "CEO & Founder",
    badgeGrad: "linear-gradient(135deg,#984A1F,#7a3b19)",
    tags: ["Ph.D Graduate", "CEO & Owner", "Bangalore"],
    meta: "Ph.D · CEO & Owner · Bangalore",
    bio: "A doctorate holder and visionary entrepreneur based in Bangalore, Dr. Shilpa founded Aarna Yours with a passion for premium fragrances. Her academic excellence and entrepreneurial spirit have shaped Aarna Yours into a trusted name in luxury perfumery across India.",
  },
  {
    img: "/img2.jpeg",
    name: "Mr. Rajendra Prasad Mishra",
    role: "Co-Founder",
    badge: "Co-Founder",
    badgeGrad: "linear-gradient(135deg,#2a0a00,#5c1f00)",
    tags: ["Co-Founder", "Management Specialist", "Operations"],
    meta: "Co-Founder · Management Specialist",
    bio: "A dedicated management specialist and the steadfast pillar behind Aarna Yours, Mr. Rajendra has been instrumental in building the operational and strategic foundation of the brand. His unwavering support and expertise in management have been key to the company's growth and success.",
  },
];

const values = [
  { icon: "gem",          title: "Premium Quality",    desc: "Only the finest ingredients in every bottle" },
  { icon: "heart-fill",   title: "Crafted with Love",  desc: "Every fragrance tells a unique story" },
  { icon: "shield-check", title: "100% Authentic",     desc: "Genuine products, guaranteed" },
  { icon: "stars",        title: "Lasting Impression", desc: "Scents that stay with you all day" },
];

const stats = [
  { num: "500+",  label: "Premium Fragrances" },
  { num: "10K+",  label: "Happy Customers" },
  { num: "5+",    label: "Years of Excellence" },
  { num: "100%",  label: "Authentic Products" },
];

const Divider = () => (
  <div style={{ width: 56, height: 4, background: "linear-gradient(90deg,#984A1F,#f5a623)", borderRadius: 4, margin: "0 auto 20px" }} />
);

const AboutUs = () => (
  <div style={{ background: "#fdf8f5", minHeight: "100vh" }}>

    {/* ── HERO ── */}
    <div style={{
      background: "linear-gradient(135deg,#1a0500 0%,#5c1f00 50%,#1a0500 100%)",
      padding: "100px 24px 80px", textAlign: "center", position: "relative", overflow: "hidden",
    }}>
      {/* glow blobs */}
      {["20% 40%","80% 60%"].map((pos, i) => (
        <div key={i} style={{
          position: "absolute", width: 400, height: 400, borderRadius: "50%",
          background: `radial-gradient(circle, rgba(152,74,31,0.3) 0%, transparent 70%)`,
          top: "50%", left: pos.split(" ")[0], transform: "translate(-50%,-50%)",
          pointerEvents: "none",
        }} />
      ))}
      <div style={{ position: "relative", zIndex: 1 }}>
        <div style={{
          display: "inline-block", background: "rgba(152,74,31,0.25)",
          border: "1px solid rgba(245,166,35,0.4)", borderRadius: 50,
          padding: "6px 22px", fontSize: 11, fontWeight: 700,
          color: "#f5c89a", letterSpacing: 3, textTransform: "uppercase", marginBottom: 22,
        }}>✦ Our Story ✦</div>
        <h1 style={{
          fontSize: "clamp(2.2rem,5vw,3.8rem)", fontWeight: 900,
          color: "#fff", margin: "0 0 18px", letterSpacing: "-1px", lineHeight: 1.1,
        }}>
          About <span style={{ color: "#f5a623" }}>Aarna Yours</span>
        </h1>
        <p style={{ color: "rgba(255,255,255,0.6)", fontSize: "1.05rem", maxWidth: 520, margin: "0 auto 32px" }}>
          Crafting premium fragrances that capture your essence and elevate every moment.
        </p>
        {/* decorative scent line */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12 }}>
          <div style={{ width: 60, height: 1, background: "rgba(245,166,35,0.4)" }} />
          <span style={{ color: "#f5a623", fontSize: 18 }}>✦</span>
          <div style={{ width: 60, height: 1, background: "rgba(245,166,35,0.4)" }} />
        </div>
      </div>
    </div>

    {/* ── FOUNDERS ── */}
    <div style={{ maxWidth: 1000, margin: "0 auto", padding: "80px 24px 72px" }}>
      <div style={{ textAlign: "center", marginBottom: 60 }}>
        <Divider />
        <h2 style={{ fontSize: "1.9rem", fontWeight: 800, color: "#1a1a1a", marginBottom: 8 }}>Meet Our Founders</h2>
        <p style={{ color: "#999", fontSize: "0.95rem" }}>The visionaries behind Aarna Yours</p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))", gap: 36 }}>
        {founders.map((f) => (
          <div key={f.name}
            style={{
              background: "#fff", borderRadius: 28,
              boxShadow: "0 16px 56px rgba(152,74,31,0.1)",
              border: "1px solid #f0e8e0",
              padding: "0 0 36px",
              textAlign: "center",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-8px)"; e.currentTarget.style.boxShadow = "0 28px 72px rgba(152,74,31,0.18)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 16px 56px rgba(152,74,31,0.1)"; }}
          >
            {/* top accent strip */}
            <div style={{ height: 8, background: "linear-gradient(90deg,#984A1F,#f5a623,#984A1F)", borderRadius: "28px 28px 0 0" }} />

            {/* circular image */}
            <div style={{ marginTop: 32, marginBottom: 24, display: "flex", justifyContent: "center" }}>
              <div style={{ position: "relative" }}>
                {/* outer glow ring */}
                <div style={{
                  position: "absolute", inset: -5,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg,#984A1F,#f5a623,#984A1F)",
                  padding: 3,
                }} />
                {/* white gap ring */}
                <div style={{
                  position: "absolute", inset: -2,
                  borderRadius: "50%",
                  background: "#fff",
                }} />
                <img
                  src={f.img}
                  alt={f.name}
                  style={{
                    width: 150, height: 150,
                    borderRadius: "50%",
                    objectFit: "cover",
                    objectPosition: "top",
                    position: "relative",
                    zIndex: 1,
                    display: "block",
                    border: "4px solid #fff",
                    boxShadow: "0 8px 32px rgba(152,74,31,0.25)",
                  }}
                  onError={e => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
                <div style={{
                  display: "none", width: 150, height: 150, borderRadius: "50%",
                  background: "linear-gradient(135deg,#f5ede6,#e8d5c4)",
                  alignItems: "center", justifyContent: "center",
                  position: "relative", zIndex: 1,
                  border: "4px solid #fff",
                }}>
                  <i className="bi bi-person-fill" style={{ fontSize: 60, color: "#984A1F", opacity: 0.5 }}></i>
                </div>
                {/* badge below image */}
                <div style={{
                  position: "absolute", bottom: -10, left: "50%", transform: "translateX(-50%)",
                  background: f.badgeGrad, color: "#fff",
                  borderRadius: 50, padding: "4px 14px",
                  fontSize: 10, fontWeight: 800, letterSpacing: 1,
                  whiteSpace: "nowrap", zIndex: 2,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                }}>
                  {f.badge}
                </div>
              </div>
            </div>

            {/* name & role */}
            <div style={{ padding: "8px 28px 0" }}>
              <h3 style={{ fontSize: "1.2rem", fontWeight: 800, color: "#1a1a1a", marginBottom: 6 }}>{f.name}</h3>
              <div style={{
                color: "#984A1F", fontWeight: 700, fontSize: "0.8rem",
                letterSpacing: 0.5, marginBottom: 18,
              }}>{f.meta}</div>

              {/* divider */}
              <div style={{ width: 40, height: 2, background: "linear-gradient(90deg,#984A1F,#f5a623)", borderRadius: 2, margin: "0 auto 18px" }} />

              <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: 1.85, marginBottom: 22, textAlign: "left" }}>{f.bio}</p>

              {/* tags */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center" }}>
                {f.tags.map(tag => (
                  <span key={tag} style={{
                    background: "rgba(152,74,31,0.07)", color: "#984A1F",
                    border: "1px solid rgba(152,74,31,0.18)",
                    borderRadius: 50, padding: "4px 13px", fontSize: 11, fontWeight: 700,
                  }}>{tag}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* ── BRAND STORY ── */}
    <div style={{ background: "#fff", padding: "72px 24px" }}>
      <div style={{ maxWidth: 860, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 44 }}>
          <Divider />
          <h2 style={{ fontSize: "1.9rem", fontWeight: 800, color: "#1a1a1a", marginBottom: 8 }}>The Aarna Yours Philosophy</h2>
          <p style={{ color: "#999", fontSize: "0.95rem" }}>Fragrance is more than a scent — it's an identity</p>
        </div>

        <div style={{
          background: "linear-gradient(135deg,#fdf8f5,#fff)",
          borderRadius: 24, padding: "44px 48px",
          boxShadow: "0 8px 48px rgba(152,74,31,0.07)",
          border: "1px solid #f0e8e0",
          borderLeft: "5px solid #984A1F",
        }}>
          {[
            "At Aarna Yours, we believe that fragrance is more than just a scent — it's an experience that captures your essence and elevates your every moment. Our collection of Perfume and Body Spray is carefully crafted to envelop you in captivating aromas that inspire confidence and leave a lasting impression.",
            "Our Perfumes are designed to cater to every mood and occasion, blending rich, luxurious notes that linger throughout the day. Whether you prefer a floral, fresh, or woody fragrance, we have something that will reflect your unique personality.",
            "For those seeking a light and refreshing touch, our Body Sprays are the perfect companion, offering an instant burst of freshness and a subtle, invigorating scent that lasts. Ideal for everyday wear, they are a must-have in your daily self-care routine.",
            "At Aarna Yours, we are dedicated to providing you with fragrances that enhance your presence and create unforgettable experiences. Embrace the power of scent and let it define your unique style.",
          ].map((p, i) => (
            <p key={i} style={{ fontSize: "1rem", color: "#444", lineHeight: 1.95, marginBottom: i < 3 ? 20 : 0 }}>{p}</p>
          ))}
        </div>

        <div style={{ textAlign: "center", marginTop: 36 }}>
          <span style={{
            fontSize: "2.2rem", fontWeight: 900, letterSpacing: 10,
            background: "linear-gradient(135deg,#984A1F,#f5a623)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          }}>AARNA</span>
        </div>
      </div>
    </div>

    {/* ── STATS ── */}
    <div style={{ background: "linear-gradient(135deg,#984A1F 0%,#7a3b19 50%,#5c2a0e 100%)", padding: "56px 24px" }}>
      <div style={{ maxWidth: 860, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 32, textAlign: "center" }}>
        {stats.map((s) => (
          <div key={s.label}>
            <div style={{ fontSize: "2.4rem", fontWeight: 900, color: "#fff", lineHeight: 1 }}>{s.num}</div>
            <div style={{ width: 28, height: 2, background: "rgba(245,166,35,0.6)", borderRadius: 2, margin: "10px auto 8px" }} />
            <div style={{ fontSize: "0.8rem", color: "rgba(255,255,255,0.7)", fontWeight: 600, letterSpacing: 0.5 }}>{s.label}</div>
          </div>
        ))}
      </div>
    </div>

    {/* ── VALUES ── */}
    <div style={{ padding: "72px 24px 80px" }}>
      <div style={{ maxWidth: 1000, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 52 }}>
          <Divider />
          <h2 style={{ fontSize: "1.9rem", fontWeight: 800, color: "#1a1a1a", marginBottom: 8 }}>Our Values</h2>
          <p style={{ color: "#999", fontSize: "0.95rem" }}>What drives everything we do</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(210px,1fr))", gap: 24 }}>
          {values.map((v) => (
            <div key={v.title} style={{
              textAlign: "center", padding: "36px 24px",
              borderRadius: 20, border: "1px solid #f0e8e0",
              background: "#fff",
              boxShadow: "0 4px 24px rgba(152,74,31,0.06)",
              transition: "transform 0.25s ease, box-shadow 0.25s ease",
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 16px 40px rgba(152,74,31,0.14)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 24px rgba(152,74,31,0.06)"; }}
            >
              <div style={{
                width: 64, height: 64, borderRadius: "50%",
                background: "linear-gradient(135deg,#984A1F,#7a3b19)",
                display: "flex", alignItems: "center", justifyContent: "center",
                margin: "0 auto 20px",
                boxShadow: "0 8px 24px rgba(152,74,31,0.3)",
              }}>
                <i className={`bi bi-${v.icon}`} style={{ fontSize: 24, color: "#fff" }}></i>
              </div>
              <div style={{ fontWeight: 800, color: "#1a1a1a", marginBottom: 10, fontSize: "1rem" }}>{v.title}</div>
              <div style={{ color: "#999", fontSize: "0.85rem", lineHeight: 1.65 }}>{v.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>

  </div>
);

export default AboutUs;
